import { api, REQUEST_TYPE } from 'store/api'
import { ModuleTags } from './consts'
import { fetchLatestBiteClassification, resolvePracticeBiteClassificationFlag } from 'utils/biteClassificationUtils'

const doctorFlagsQuery = /* GraphQL */ `
  query BiteClassificationDoctorFlags($id: ID!) {
    getDoctor(id: $id) {
      id
      accountOwnerId
      user {
        featureFlags {
          flags
        }
      }
    }
  }
`

const latestBiteQuery = /* GraphQL */ `
  query LatestBiteClassification($patientId: ID!, $nextToken: String) {
    grinScansByPatientIdSorted(
      patientId: $patientId
      sortDirection: DESC
      filter: { trackingStatus: { eq: "submitted" }, trackingDetails: { contains: "biteClassification" } }
      limit: 50
      nextToken: $nextToken
    ) {
      items {
        id
        _deleted
        createdAt
        trackingStatus
        trackingDetails
      }
      nextToken
    }
  }
`

export const BiteClassification = api.injectEndpoints({
  endpoints: build => ({
    fetchBiteClassificationPracticeFlag: build.query({
      queryFn: ({ doctorId }, queryApi, extraOptions, baseQuery) =>
        resolvePracticeBiteClassificationFlag(doctorId, id =>
          baseQuery({ type: REQUEST_TYPE.GRAPHQL, query: doctorFlagsQuery, variables: { id } })
        )
    }),
    fetchLatestBiteClassification: build.query({
      queryFn: ({ patientId }, queryApi, extraOptions, baseQuery) =>
        fetchLatestBiteClassification(nextToken =>
          baseQuery({ type: REQUEST_TYPE.GRAPHQL, query: latestBiteQuery, variables: { patientId, nextToken } })
        ),
      providesTags: [ModuleTags.PatientCopilot]
    })
  })
})

export const { useFetchBiteClassificationPracticeFlagQuery, useFetchLatestBiteClassificationQuery } = BiteClassification
